import moment, { Moment } from "moment";
import { KeyboardEvent } from 'react';

export const formatCurrency = (currency: number | string): string => {
	const rs = currency.toLocaleString("en-US", {
		style: "currency",
		currency: "USD",
	});
	return rs;
};

export const formatDate = (date?: Moment | string | Date): string | null => {
	if (!date) return null;
	const rs = moment(date).format("MM/DD/yyyy").toString();
	return rs;
};

export const formatDateISO = (date?: Moment | string | Date): string | null => {
	if (!date) return null;
	const rs = moment(date).format("yyyy-MM-DD").toString();
	return rs;
};

export const formatDateTime = (
	date?: Moment | string | Date | null,
): string | null => {
	if (!date) return null;
	const rs = moment(date).format("MM/DD/yyyy HH:mm:ss").toString();
	return rs;
};

export const formatDateTimeNoSecond = (
	date?: Moment | string | Date | null,
): string | null => {
	if (!date) return null;
	const rs = moment(date).format("MM/DD/yyyy hh:mma").toString();
	return rs;
};

export const formatDateMobile = (
	date?: Moment | string | Date | null,
): string | null => {
	if (!date) return null;

	const year = new Date(date.toString()).getFullYear()
	const currentYear = new Date().getFullYear();	

	const rs = moment(date).format(year < currentYear? "MM/DD/yyyy":"MMM D").toString();
	return rs;
};

export const getDateFromMultiDate = (dates: string): string | null => {
	return dates
		?.split(",")
		.map((x) => formatDate(x))
		.join(", ");
};

export const formatDateTimeToLocalTime = (date?: Date| string) : string | null => {
	if (!date) return null;
	
	const rs = moment.utc(date).local().toString();

	return rs;
}

export const formatNumberCurrency = (value: any) => {
    if (!value) return "";
    const numericValue = parseFloat(value.replace(/[^0-9.]/g, "") || 0).toFixed(2);
    return `$${numericValue}`;
};

export const isNumber = (str: string) => {
	const regex = /^-?\d+(\.\d+)?$/;
    return regex.test(str);
};

export const handleStatusMessage = (statusId : any) => {
    switch (statusId) {
      case 1:
        return "Pending Approval";
      case 2:
        return "Approved";
      case 3:
        return "Pending Modification";
      default:
        return undefined;
    }
};

export const handleNumericDateInput = (e: KeyboardEvent<HTMLInputElement>) => {
	
	const isNumericKey = /^(?:\d|Numpad\d|NumpadDivide)$/.test(e.key);

	const isAllowedKey = [
	  '/', 
	  'Tab', 
	  'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
	  'Delete', 'Backspace', 
	  'Home', 'End'
	].includes(e.key);
  
	const isCopyPaste = (e.ctrlKey || e.metaKey) && 
					  ['c', 'v', 'x', 'a'].includes(e.key.toLowerCase());
  
	const isPasteFromMouse = e.key === 'Unidentified';
  
	if (!isNumericKey && !isAllowedKey && !isCopyPaste && !isPasteFromMouse) {
	  e.preventDefault();
	}
  };